var _desc, _path, _polygon, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcIso7010(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    enableBackground: "new 0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "sign_border",
    strokeMiterlimit: 10,
    d: "M56.7,48.9L31.3,5c-0.3-0.4-0.7-0.7-1.2-0.7 s-1,0.3-1.2,0.7L3.5,49c-0.3,0.4-0.3,1,0,1.4s0.7,0.7,1.2,0.7h50.8c0.5,0,1-0.3,1.2-0.7C56.9,49.9,56.9,49.4,56.7,48.9L56.7,48.9z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "polygon7",
    fill: "#FEE633",
    points: "53,48.2 7.2,48.2 30.1,8.7 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1933",
    d: "M29.2,19.3l-4.5,15.4l6.6-3.4l-1.4,10.3l-1.4-2l1,6.5l3.8-5.5l-1.9,1.2l4-14.7L28.3,31l5.2-11.8L29.2,19.3 L29.2,19.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIso7010);
export default __webpack_public_path__ + "static/media/ic-ISO-7010.97acac59c2d68746d31d9736fb90f823.svg";
export { ForwardRef as ReactComponent };